
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/productos/[pid]",
      function () {
        return require("private-next-pages/productos/[pid]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/productos/[pid]"])
      });
    }
  